export default __webpack_public_path__ + "static/react-8d64c6a929de5bd6d0fc201e687f6ce6.png";